import useGeneralStore from '../../../../store/general';
import customHeaders, { getSpace } from '../../../../common/headers';
import { ButtonActionDrop } from '../../../Buttons/ButtonActionDrop/ButtonActionDrop';
import useModal from '../../../../store/modal';
import { useShallow } from 'zustand/react/shallow';
import './RoleRow.scss'
import { TextPage } from '../../../TextPage/TextPage';
import { useResponseHandler } from '../../../../common/auth';
import { usePushNotifications } from '../../../../common/pushNotification';

const RoleRow = ({
    id,
    update,
    name,
    key,
    access,
    is_editable,
    permission_groups,
    isAdmin
}) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const setIsModalRole = useGeneralStore((state) => state.setIsModalRole);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };
    const { handleTableResponse, handleRequestError } = useResponseHandler();
    const { addErrorPush, addSuccessPush } = usePushNotifications();
    const { selectedRole, setSelectedRole } = useModal(
        useShallow((state) => ({
            selectedRole: state.selectedRole,
            setSelectedRole: state.setSelectedRole
        }))
    );

    // Удалить роль
    const fetchDeleteRole = (id) => {
        let url = `https://apps0.ecomru.ru:4242/api/v2/space/roles/${selectedSpace?.value}/${id}`;

        fetch(url, { method: 'DELETE', headers })
            .then(response => {
                if (response.status === 400) {
                    return response.json().then(data => {
                        addErrorPush(data?.detail)
                        throw { status: 400, data };
                    });
                }
                return handleTableResponse(response);
            })
            .then((json) => setTimeout(() => update(), 100))
            .catch(handleRequestError)
    }

    const editRole = () => {
        setSelectedRole({ id, permission_groups, name })
        setIsModalRole(true)
    }

    const btns = [
        { btn: 'Редактировать', func: () => editRole() },
        { btn: 'Удалить', func: () => fetchDeleteRole(id) }
    ];

    return (
        <div className='role-row' key={key}>
            <div className='role-row__name'>
                <span>{name + ' '}
                    {(access?.length > 0) &&
                        <>
                            <br />
                            <span style={{ display: 'inline', color: '#94A3B8', fontSize: '11px' }}>
                                ({access.map((el, ind) => <TextPage
                                    key={el}
                                    text={el + ((access.length == ind + 1) ? '' : ', ')}
                                    style={{ display: 'inline', color: '#94A3B8', fontSize: '11px' }}
                                />)})
                            </span>
                        </>
                    }
                </span>
            </div>
            <div className='role-row__tools'>
                {
                    (is_editable && isAdmin) ?
                        <div className='role-row__btns'>
                            <ButtonActionDrop
                                id={id}
                                btns={btns}
                            />
                        </div>
                        :
                        null
                }
            </div>
        </div>
    )
}

export { RoleRow }
